import { Notifier } from "@airbrake/browser";

if (process.env.client_airbrake_project_id && process.env.client_airbrake_project_key) {
  const airbrake = new Notifier({
    projectId: Number(process.env.client_airbrake_project_id),
    projectKey: process.env.client_airbrake_project_key,
  });

  airbrake.addFilter((notice) => {
    notice.context.environment = "js" + process.env.RAILS_ENV;
    return notice;
  });

  window.onerror = function (_message, _source, _lineno, _colno, error) {
    airbrake.notify(error);
  };
}
